import { format } from "date-fns";

export const numberFormat = (numberFormat, precision = 2) => ({
  formatter: value => {
    if (value == null || value === "") return "";

    const num = parseFloat(value);
    if (Number.isNaN(num)) return "0";

    if (Number.isInteger(num)) {
      return num.toString();
    }

    return num.toFixed(precision).replace(".", numberFormat || ".");
  },
});

export const currencyFormat = (currencySymbol, value, numberFormat, precision = 2) => {
  if (value == null || value === "") return "";

  const num = parseFloat(value);
  if (Number.isNaN(num)) return "0";

  let formatted;
  if (Number.isInteger(num)) {
    formatted = num.toString();
  } else {
    formatted = num.toFixed(precision).replace(".", numberFormat || ".");
  }

  return `${currencySymbol} ${formatted}`;
};

const toDurationParts = value => {
  if (value == null || value === "") return null;

  const num = typeof value === "number" ? value : parseFloat(value);
  if (!Number.isFinite(num)) return null;

  const totalMinutes = Math.round(Math.abs(num) * 60);
  const minutes = totalMinutes % 60;

  return {
    sign: num < 0 ? "-" : "",
    minutes,
    totalHours: (totalMinutes - minutes) / 60,
  };
};

export const toHHmm = value => {
  const parts = toDurationParts(value);
  if (parts === null) return "";

  const { sign, minutes, totalHours } = parts;

  return `${sign}${String(totalHours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

export const toAccumulated = value => {
  const parts = toDurationParts(value);
  if (parts === null) return "";

  const { sign, minutes, totalHours } = parts;

  if (totalHours < 24) return `${sign}${totalHours}h ${minutes}m`;

  const hours = totalHours % 24;

  return `${sign}${(totalHours - hours) / 24}d ${hours}h ${minutes}m`;
};

const DURATION_FORMATS = {
  hhmm: { formatter: toHHmm },
  accumulated: { formatter: toAccumulated },
};

export const durationColumn = kind => ({
  dataType: "number",
  alignment: "right",
  format: DURATION_FORMATS[kind],
  allowFiltering: false,
  allowHeaderFiltering: false,
});

export const dateTimeFormatGrid = pattern => {
  if (!pattern) return pattern;

  let fixedMask = pattern;

  fixedMask = fixedMask
    .replace(/YYYY/g, "yyyy")
    .replace(/YYY/g, "yyy")
    .replace(/YY/g, "yy")
    .replace(/Y/g, "y");

  if (fixedMask.indexOf("dddd") > -1) fixedMask = fixedMask.replace("dddd", "EEEE");
  else if (fixedMask.indexOf("ddd") > -1) fixedMask = fixedMask.replace("ddd", "EE");
  else if (fixedMask.indexOf("dd") > -1) fixedMask = fixedMask.replace("dd", "EE");

  fixedMask = fixedMask.replaceAll("D", "d");

  fixedMask = fixedMask.replace("A", "a");

  return fixedMask;
};

export const formatDate = (date, pattern) => {
  if (!date || !pattern) return "";

  try {
    return format(new Date(date), dateTimeFormatGrid(pattern));
  } catch {
    return "";
  }
};
